"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../../../components/Button"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var DropDown = function (_a) {
    var moreDropdownRef = _a.moreDropdownRef, appliedFiltersCount = _a.appliedFiltersCount, moreIsActive = _a.moreIsActive, toggleMoreFilters = _a.toggleMoreFilters, dropdownItems = _a.dropdownItems, resetFilters = _a.resetFilters;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { ref: moreDropdownRef, className: classnames_1.default('more-filters', {
            'filters-applied': appliedFiltersCount,
            active: moreIsActive,
        }) },
        react_1.default.createElement("div", { onClick: toggleMoreFilters, className: "more-text" },
            react_1.default.createElement("span", null, t('FILTER.MORE'))),
        react_1.default.createElement("div", { className: "more-dropdown" },
            react_1.default.createElement("div", { className: "inner" }, dropdownItems
                .sort(function (a, b) {
                return parseInt(a.key) - parseInt(b.key);
            })
                .map(function (item) { return (react_1.default.createElement(react_1.default.Fragment, { key: item.key }, item)); })),
            react_1.default.createElement("div", { className: "filters-actions" },
                appliedFiltersCount > 0 && (react_1.default.createElement("a", { className: "clear-filters", onClick: resetFilters },
                    t('FILTER.CLEAR_FILTERS'),
                    "(",
                    appliedFiltersCount,
                    ")")),
                react_1.default.createElement("div", { className: "close-button-wrapper" },
                    react_1.default.createElement(Button_1.default, { variant: "outline", onClick: toggleMoreFilters, className: "close-button" }, t('FILTER.CLOSE')))))));
};
exports.default = react_1.memo(DropDown);
